import {IPropertySpec, PropertySpec, PropName} from '@mintdata/mint-kit/api/properties/PropertySpec';
import {PropertyUtils} from '@mintdata/mint-kit/api/properties/PropertyUtils';
import {list, object, optional, PropSchema, serializable} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';

// @Property(spec)

export function Property<T>(spec:IPropertySpec<T>):PropertyDecorator
{
    return function(target:any, propName:PropName, propertyDescriptor?:PropertyDescriptor):void
    {
        let propertyMap = PropertyUtils.getOrCreatePropertyMap(target);

        propertyMap.add(new PropertySpec(
            propName,
            spec.title,
            spec.tip,
            spec.category,
            true,
            spec.isRequired,
            spec.isIgnoredByRepeater,
            spec.typeConfig,
            spec.typeCtor,
            spec.binding,
            spec.isManualConfirmation,
            spec.keepValueAfterBindingRemoving
        ));

        if( propertyDescriptor && propertyDescriptor.get )
        {
            if( !propertyDescriptor.set )
                console.warn(`Virtual Property ${target.constructor.name}.${propName} setter not defined`);
        }
        else if( spec.typeCtor && (!propertyDescriptor || !propertyDescriptor.get) )
        {
            const typeSchema:PropSchema = spec.typeConfig.isArray ? list(object(spec.typeCtor)) : object(spec.typeCtor);
            const resultTypeSchema:PropSchema = !spec.isRequired ? optional(typeSchema) : typeSchema;

            serializable(resultTypeSchema)(target, propName, propertyDescriptor);
        }
        else
            console.warn(`spec.typeCtor not defined for ${target.constructor.name}.${propName}`);
    };
}
